import store from 'store';
const userStore = store.get('userRf1');
var initialState = {
  user: {},
  isAuthenticated: false
};
if (userStore) {
  initialState = {
    user: userStore,
    isAuthenticated: true
  };
}
export default function user(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_USER':
      return {
        user: action.payload,
        isAuthenticated: true
      };
    case 'LOGOUT_USER':
      return {
        user: {},
        isAuthenticated: false
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/user.js
 **/